import {
    formatMarginalia,
    formatPrimitiveMarginalia,
} from '@/learn/kanji/[frame]/_lib/format-marginalia'

// Row 1 — `EDITION I · LESSON N · FRAME M / 2,200`, or `· PRIMITIVE` for
// primitive frames (unnumbered by decision — the keyword on the card carries
// identity). Editorial header of a study card. Tabular numerals so the frame
// counter doesn't shift width as the user advances through the lesson.
// Muted-fg, no vermilion (§7) — position fact, not progress accent.
export function MarginaliaTop({
    lessonNumber,
    frame,
    primitive = false,
}: {
    lessonNumber: number
    frame: number
    primitive?: boolean
}) {
    return (
        <p className="text-meta text-muted-fg uppercase tabular-nums">
            {primitive
                ? formatPrimitiveMarginalia(lessonNumber)
                : formatMarginalia(lessonNumber, frame)}
        </p>
    )
}
